/**
 * Function for populating a button that triggers a drawer component.
 */

import { Button, Spin } from 'antd';
import { includes, isEmpty } from 'lodash';
import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { getUserCompanyRole } from '../../store/companies/sagas';
import { populatePopoverContainer } from '../../utils/commonFunctions';

const Drawer = lazy(() => import('antd/lib/drawer'));

interface IProps {
    readonly containerRef?: any;
    readonly allowedRoles?: string[];
    readonly popoverClassName?: string;
    readonly popoverVisible?: boolean;
    readonly popoverTitle?: any;
    readonly popoverContent: any;
    readonly buttonType:
        | 'link'
        | 'default'
        | 'ghost'
        | 'primary'
        | 'dashed'
        | 'danger'
        | undefined;
    readonly buttonClassName?: string;
    readonly buttonContent: any;
    readonly buttonRestProps?: any;
    readonly drawerCloseable: boolean;
    readonly drawerWidth?: any;
}
const ProtectedDrawerButton: React.FC<IProps> = ({
    containerRef,
    allowedRoles,
    popoverVisible,
    popoverTitle,
    popoverContent,
    buttonType,
    buttonClassName,
    buttonContent,
    buttonRestProps,
    drawerCloseable,
    drawerWidth,
}: IProps) => {
    const userRole = useSelector(getUserCompanyRole);
    if (isEmpty(allowedRoles) || includes(allowedRoles, userRole)) {
        return (
            <>
                <Button
                    type={buttonType}
                    className={buttonClassName}
                    {...buttonRestProps}
                >
                    {buttonContent}
                </Button>
                <Suspense fallback={<Spin />}>
                    <Drawer
                        visible={popoverVisible}
                        getContainer={populatePopoverContainer(containerRef)}
                        closable={drawerCloseable}
                        title={popoverTitle}
                        width={drawerWidth || 420}
                        className="protected-drawer"
                    >
                        {popoverVisible && popoverContent}
                    </Drawer>
                </Suspense>
            </>
        );
    } else {
        return null;
    }
};

export default ProtectedDrawerButton;
